import styled from "styled-components"
import { MdMoreHoriz } from "react-icons/md";
import { setSelectedKayitliYuk } from "../../features/kayit/kayitSlice";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
const Container = styled.div`

    width: 100%;
    display: flex;
    flex-wrap: wrap;
    color: ${({theme}) => theme.mainTextColor};
    background-color: ${({theme}) => theme.secondaryBgColor};
    gap: 20px;
    border-radius: 10px;
    padding: 20px;
    justify-content: space-between;
    position: relative;

    .content-item{
        font-size: var(--font-size-sm);
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: center;
        text-align: center;

        .title{
            font-weight: var(--font-weight-xl);
        }

        .text{
            font-weight: var(--font-weight-md);

        }
    }

    .more{
        position: absolute;
        right: 10px;
        top: 10px;
        span{
          font-size: 25px;
          color: ${({ theme }) => theme.mainTextColor};
          cursor: pointer;
        }
        .option{
          position: absolute;
          right: 30px;
          top: 5px;
          color: var(--color-main);
          cursor: pointer;
        }
      }

    @media (max-width: 850px) {
        .content-item{
            width: calc(33% - 20px);
        }
    }


    @media (max-width: 460px) {
        .content-item{
            width: calc(50% - 20px);
        }
    }
    
`

const KayitliYuklerContainerMobile = ({data}) => {

    const dispatch = useDispatch()

  return (
    <Container>
        <div className="content-item">
            <div className="title">Ön Tanımlı Yük Kaydı Adı</div>
            <div className="text">{data?.saveLoadName}</div>
        </div>

        <div className="content-item">
            <div className="title">Gönderilen İl</div>
            <div className="text">{data?.senderAdressCity}</div>
        </div>

        <div className="content-item">
            <div className="title">Gönderen İlçe</div>
            <div className="text">{data?.senderAdressTown}</div>
        </div>

        <div className="content-item">
            <div className="title">Gönderilecek İl</div>
            <div className="text">{data?.receiverCity}</div>
        </div>

        <div className="content-item">
            <div className="title">Gönderilecek İlçe</div>
            <div className="text">{data?.receiverAdressTown}</div>
        </div>

        <div className="content-item">
            <div className="title">Araç</div>
            <div className="text">{data?.truckType}</div>
        </div>

        <div onClick={() => {dispatch(setSelectedKayitliYuk(data)); dispatch(showModal("yukKayitItemOptions"))}}  className="more">
              <MdMoreHoriz />
          </div>
    </Container>
  )
}

export default KayitliYuklerContainerMobile
